import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=6df9f32f&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=6df9f32f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9f32f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df9f32f')) {
      api.createRecord('6df9f32f', component.options)
    } else {
      api.reload('6df9f32f', component.options)
    }
    module.hot.accept("./app-header.vue?vue&type=template&id=6df9f32f&scoped=true&", function () {
      api.rerender('6df9f32f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/app-header.vue"
export default component.exports